// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InputRange from '../dashboard/inputRange';
import DashboardIcon from '../dashboard/icons/DashboardIcon';
// import '../../sass/find_contractor/find_contractor.scss';
// import '../../sass/find_contractor/find_contractor-l.scss';
// import '../../sass/find_contractor/find_contractor-m.scss';

const SearchElement = ({
  searchData, profile, getSearchValues, showInputRange, activeTab,
}) => {
  const [range, handlerRange] = useState(
    showInputRange
      ? searchData.range : (searchData.range || 60),
  );

  useEffect(() => {
    if (searchData.range !== range) {
      handlerRange(searchData.range);
    }
  }, [searchData.range]);

  const handlerSubmit = event => {
    event.preventDefault();
    const result = {
      search: event.target.search.value,
      search_zip: event.target.search_zip.value,
    };
    if (
      showInputRange || profile.userType === 'contractor'
    ) return getSearchValues({ ...result, range });
    return getSearchValues(result);
  };

  const searchPlaceholder = showInputRange
    ? 'Search'
    : (profile.userType === 'contractor' ? 'Search' : 'Search work orders...');

  return (
    <form className="search-group" onSubmit={handlerSubmit}>
      <input
        type="text"
        name="search"
        maxLength={50}
        aria-label="search"
        placeholder={searchPlaceholder}
        className="dashboard-input"
        defaultValue={searchData.search}
      />
      <input
        type="text"
        name="search_zip"
        maxLength={8}
        aria-label="zip code"
        placeholder="Zip code"
        className="dashboard-input dashboard-input--zip"
        defaultValue={searchData.search_zip || ''}
      />
      <div className="search-range-row">
        {
          showInputRange
          || (profile.userType === 'contractor' && activeTab === 'available')
            ? (
              <div className="search-range-wrap">
                <InputRange
                  defaultValue={range}
                  handler={handlerRange}
                />
              </div>
            )
            : null
        }
        <button className="dashboard-btn-search" aria-label="Search" type="submit">
          <DashboardIcon name="search" size={20} strokeWidth="2.5" />
        </button>
      </div>
    </form>
  );
};

const mapStateToProps = state => ({
  profile: state.profile,
  searchData: state.workOrder.searchData,
  activeTab: state.applicationState.activeTab,
});

export default connect(mapStateToProps)(withRouter(SearchElement));
